import { pickBy } from 'lodash';
import { createSelector } from '@reduxjs/toolkit';
import { PERSON_STATES } from '../constants';
import {
  getAllPersonsService,
  getPersonsWithAccessLevelsService,
} from '../services/personsService';
import { compareLocal, sortBy } from '../utils/helpers';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// async thunk
export const getPersons = createAsyncThunk('persons/getPersons', async () => {
  const response = await getAllPersonsService();
  return response.data;
});

// slice
const personsSlice = createSlice({
  name: 'persons',
  initialState: {},
  reducers: {
    removePerson(state, action) {
      const { [action.payload]: value, ...withoutPerson } = state;
      return withoutPerson;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPersons.pending, (state) => {
        console.log('Fetching all persons...');
      })
      .addCase(getPersons.fulfilled, (state, action) => {
        return { ...state, ...action.payload };
      })
      .addCase(getPersons.rejected, (state, action) => {
        console.error('Failed to fetch persons:', action.error);
      });
  },
});

export default personsSlice.reducer;
export const { removePerson } = personsSlice.actions;

// Selectors
export const selectPersons = (state) => state.persons;

export const selectActivePersons = (state) => {
  return pickBy(state.persons, (person) => {
    return person.state === PERSON_STATES.ACTIVE;
  });
};

export const selectActivePersonsArray = createSelector(
  selectPersons,
  (persons) => {
    return Object.values(persons).filter((person) => {
      return person.state === PERSON_STATES.ACTIVE;
    });
  }
);
export const selectAllPersonsArray = createSelector(selectPersons, (persons) =>
  Object.values(persons)
);

export const selectActivePersonsSortOrder = createSelector(
  selectActivePersonsArray,
  (activePersons) => {
    return sortBy(activePersons, [(a, b) => compareLocal(a.name, b.name)]).map(
      (person) => person.id
    );
  }
);

export const selectAllPersonsSortOrder = createSelector(
  selectAllPersonsArray,
  (activePersons) => {
    return sortBy(activePersons, [(a, b) => compareLocal(a.name, b.name)]).map(
      (person) => person.id
    );
  }
);

export const selectArchivedPersonsSortOrder = (state) =>
  sortBy(
    Object.keys(state.persons).filter(
      (id) => state.persons[id].state === PERSON_STATES.ARCHIVED
    ),
    [(a, b) => compareLocal(state.persons[a].name, state.persons[b].name)]
  );
